import { inject } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot } from '@angular/router';
import { makeStateKey, TransferState } from '@angular/core';
import { get } from 'lodash';
import { Observable, of } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
// Service
import { PartSearchService } from '../../partsearch-shared-module/service';

// KEY
const STATE_KEY_CATEGORIES = makeStateKey('category');

export const CategoryResolverService: ResolveFn<any> = (route: ActivatedRouteSnapshot): Observable<any> => {
    const partSearchService = inject(PartSearchService);
    const transferState = inject(TransferState);

    // Check if data is already provided by SSR
    if (transferState.hasKey(STATE_KEY_CATEGORIES)) {
        const result = of(transferState.get<any>(STATE_KEY_CATEGORIES, []));
        transferState.remove(STATE_KEY_CATEGORIES);
        return result;
    }

    const payload = getCategoryPayload(route);

    return partSearchService.getCategories(payload).pipe(
        take(1),
        catchError(() => of([]))
    );
};

/**
 * Generate category payload based on route data.
 * @param {ActivatedRouteSnapshot} route
 * @returns {any}
 */
const getCategoryPayload = (route: ActivatedRouteSnapshot): any => {
    const sourcePath: string = get(route, 'data.path', 'S1');

    switch (sourcePath) {
        case 'S1': // Regular Path
            return {
                sm: 1,
                code_vc_make_model: get(route, 'params.code_vc_make_model'),
                code_vc_myft: get(route, 'params.code_vc_myft'),
                vt1: get(route, 'params.vt1'),
                path: '/{lang}/pb/{label_search}/{label_car_parts}/s1/{vc1}/{vc}/{vcx}',
            };

        case 'OV': // OV Path
            return {
                sm: 1,
                code_vc_make_model: get(route, 'params.code_vc_make_model'),
                code_vc_myft: get(route, 'params.code_vc_myft'),
                vt1: get(route, 'params.vt1'),
                path: '/{lang}/ov/{label_search}/{label_car_parts}/{vc1}/{vc}/{vcx}',
            };

        case 'S9': // S9/AP (All Products)
            return {
                sm: 9,
                path: '/{lang}/pb/{label_search}/{label_car_parts}/s9/AP'
            };

        case 'S17': // a/a Path
            return {
                sm: 17,
                vt1: get(route, 'params.vt1'),
                path: '/{lang}/pb/{label_search}/{label_car_parts}/s17/{vc1}/a/a',
            };

        case 'S19': // S19 Path
            return {
                sm: 19,
                vt1: get(route, 'params.vt1'),
                vt2: get(route, 'params.vt2'),
                path: '/{lang}/pb/{label_search}/{label_car_parts}/s19/{vc1}/{vc2}',
            };

        default:
            return {};
    }
};
